<template lang="html">
  <div class="seller-rating-wrapper">
    <div v-for="(key, index) in keys" :key="index">
      <div v-if="rating[key]" class="info">
        <span class="info-key">{{$t('details.sellerRating.' + key)}}:</span>
        <rating v-if="key === 'rat_rating'" :rating="parseFloat(rating[key])" />
        <span v-else class="info-value">{{rating[key]}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Rating from '@/components/rating.vue'
export default {
  name: 'SellerRating',
  props: {
    rating: {
      type: Object,
      required: true
    }
  },
  components: {
    Rating
  },
  data () {
    return {
      keys: [
        'pro_name',
        'usr_name',
        'rat_date',
        'rat_rating',
        'rat_comment'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.seller-rating-wrapper {
  border: 1px solid rgba(243, 243, 243, 0.5);
  box-sizing: border-box;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.09);
  width: 100%;
  padding: 30px;
  margin-bottom: 30px;

  .info {
    margin-bottom: 10px;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    text-align: left;
    flex-wrap: wrap;

    .info-key {
      font-weight: normal;
      font-size: 13px;
      line-height: 21px;
      color: #787878;
      margin-right: 15px;
      white-space: nowrap;
    }
    .info-value {
      font-weight: 800;
      font-size: 13px;
      line-height: 21px;
      letter-spacing: 0.02em;
      color: $text-color;
    }
  }
}
</style>
